export default function sisSyncPath(orgId: number | string): string {
  return `/organizations/${orgId}/sis_sync`;
}
